import { defineStore } from 'pinia';
import { IStoreApiState } from './api.interface';
import ApiState from './state';
import {
  _addAbortController,
  _removeAbortController,
  _clearApiRequests,
  _clear,
} from './actions';

export const useApiStore = defineStore('api', {
  state: (): IStoreApiState => ({ ...ApiState }),
  actions: {
    addAbortController(abortController: AbortController) {
      _addAbortController(this, abortController);
    },
    removeAbortController(abortController: AbortController) {
      _removeAbortController(this, abortController);
    },
    clearApiRequests() {
      _clearApiRequests(this);
    },
    clear() {
      _clear(this);
    },
  },
});
